import React, { useState, useEffect } from "react";
import "./VehicleBrands.css";
import { useNavigate, useParams } from "react-router-dom";
import useApiRequest from "../../hooks/useApiRequest";
import Spinner from "../shared/spinner";
import { getImageUrl } from "../../utils/helpers";

const VehicleBrands = ({ changeBanner }) => {
  let { vehicleBrandId } = useParams();

  const {
    data: allCars,
    isLoading,
    error,
  } = useApiRequest(`/makes?type=${vehicleBrandId}`);

  const navigate = useNavigate();

  const goBackToVehicleTypeSelection = () => {
    navigate("/");
  };

  useEffect(() => {
    changeBanner(false);
  }, []);

  const goToVehicleSeries = (brandId) => {
    navigate(`/${vehicleBrandId}/${brandId}`);
  };

  if (isLoading) {
    return <Spinner />;
  }

  return (
    <div>
      <h1
        className="flex items-center justify-center mt-12 mb-6 font-bold text-center text-2xl sm:text-4xl"
        style={{ color: "#121212" }}
      >
        Select the Manufacturer
      </h1>
      <div className="flex flex-wrap justify-center gap-8">
        {allCars?.map((brand, index) => (
          <div
            key={index}
            className="bg-white rounded-lg overflow-hidden shadow-xl hover:shadow-xl hover:translate-y-1 hover:flip vehicleBrandCards"
            style={{
              minHeight: "200px",
              width: "300px",
              padding: "12px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "space-around",
            }}
            onClick={() => goToVehicleSeries(brand?.id)}
          >
            <img
              src={getImageUrl(brand?.imageUrl || window.DEFAULT_IMAGE_URL)}
              alt={`${brand?.name} Logo`}
              className="object-cover object-center transition-transform"
              style={{ width: "100px" }}
              onError={(e) => {
                e.target.src = window.DEFAULT_IMAGE_URL;
              }}
            />
            <div className="p-2 text-center">
              <p className="text-lg font-semibold">{brand?.name}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-12 mb-6 flex items-center justify-end p-6 backButtonBrand">
        <button
          className="btnn btnBrandd"
          style={{ borderRadius: "8px" }}
          onClick={goBackToVehicleTypeSelection}
        >
          Go Back To Vehicle Type Selection
        </button>
      </div>
    </div>
  );
};

export default VehicleBrands;
